import styled from "styled-components";

export const SmallDesignCardWrapper = styled.div`
  background: rgb(31, 31, 31);
  box-shadow: 10px 9px 11px rgba(0, 0, 0, 0.25);
  border-radius: 25px;
  overflow: hidden;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  @media (max-width: 1199px) {
    padding: 15px;
    border-radius: 15px;
  }
  @media (max-width: 899px) {
    padding: 12px;
    border-radius: 10px;
  }
  i {
    width: 60px;
    height: 60px;
    background: rgb(255, 24, 24);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-radius: 100%;
    margin-bottom: 8px;
    @media (max-width: 899px) {
    width: 50px;
    height: 50px;
    padding: 7px;
    }
  }
  p {
    font-weight: 600;
    font-size: 24px;
    color: rgba(255, 255, 255, 1);
    @media (max-width: 1199px) {
      font-size: 18px;
    }
    @media (max-width: 899px) {
      font-size: 16px;
    }
    @media (max-width: 599px) {
      font-size: 14px;
    }
  }
`;
